module.exports = __webpack_public_path__ + "img/Popup_Bevoelkerung.b7e9b11f.png";